import { Phone, Mail, MapPin } from "lucide-react";
import { LogoMark } from "./Logo";
import { SITE } from "@/constants/site";

const COLS = [
  { title: "Study Abroad", links: ["USA", "UK", "Germany", "Latvia"], href: "#destinations" },
  { title: "Advisory", links: ["Institutional Setup in India", "Twinning & Partnerships", "Apprentice Placement"], href: "#advisory" },
  { title: "Company", links: ["Our Process", "Success Stories", "Book Counselling"], href: "#process" },
];

export const Footer = () => (
  <footer data-testid="footer" className="bg-[#0B192C] text-slate-300 pt-16 pb-8 border-t border-amber-500/20">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <div className="flex items-center gap-3 pb-10 border-b border-white/10">
        <LogoMark className="w-11 h-11" dark />
        <div>
          <p className="font-heading font-bold text-2xl sm:text-3xl text-white leading-none">Orion Edcon Services</p>
          <p className="text-xs uppercase tracking-[0.25em] text-amber-400 mt-1.5">Architecting Global Futures</p>
        </div>
      </div>
      <div className="grid md:grid-cols-5 gap-10 pt-10">
        <div className="md:col-span-2">
          <p className="text-sm leading-relaxed max-w-sm text-slate-400">
            One-stop support for international education in the USA, UK, Germany and Latvia — and governance advisory
            for institutions building campuses and partnerships in India.
          </p>
          <div className="mt-6 space-y-2.5 text-sm">
            <a href={SITE.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-2 hover:text-amber-400 transition-colors">
              <Phone className="w-4 h-4 text-amber-400" /> {SITE.phone}
            </a>
            <a href={`mailto:${SITE.email}`} data-testid="footer-email-link" className="flex items-center gap-2 hover:text-amber-400 transition-colors">
              <Mail className="w-4 h-4 text-amber-400" /> {SITE.email}
            </a>
            <p className="flex items-start gap-2"><MapPin className="w-4 h-4 text-amber-400 mt-0.5 shrink-0" /> {SITE.city}</p>
          </div>
        </div>
        {COLS.map((col) => (
          <div key={col.title}>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white">{col.title}</h4>
            <ul className="mt-4 space-y-2.5">
              {col.links.map((l) => (
                <li key={l}>
                  <a href={col.href} className="text-sm text-slate-400 hover:text-amber-400 transition-colors">{l}</a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-500">
        <p>© {new Date().getFullYear()} Orion Edcon Services · {SITE.domain}. All rights reserved.</p>
        <p>Admissions · Visas · Institutional Advisory · Apprentice Placement</p>
      </div>
    </div>
  </footer>
);
